import styled from 'styled-components'

import { colors } from '../../../utils/helpers/colors'
import { BASE_BREAKPOINTS } from '../../../utils/enhancers/withResponsive'

export const SectionContainer = styled.section`
  margin-left: 64px;
  margin-right: 64px;
  margin-bottom: 24px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
  }
`

export const StyledSectionContainer = styled(SectionContainer)`
  background-color: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 32px;

  &:first-of-type {
    padding-top: 32px;
  }

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    padding-top: 24px;
    padding-left: 22px;
    padding-right: 22px;
  }
`

export const HalfSectionContainer = styled.section`
  display: flex;
  padding-left: 64px;
  padding-right: 64px;

  & > section {
    &:first-child {
      flex: ${props => (props.description === '' ? 1 : 2)} 1;
      margin-right: ${props => (props.column ? '0' : '12px')};
      margin-left: 0;

      ${props => (props.description === '' ? 'flex-basis: 50%;' : '')};
    }

    &:last-child {
      flex: 1 1;
      margin-left: ${props => (props.column ? '0' : '12px')};
      margin-right: 0;

      ${props => (props.description === '' ? 'flex-basis: 50%;' : '')};
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const FullSectionContainer = styled.section`
  @media (min-width: 769px) {
    display: none;
  }
`

export const HalfSectionColumnContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  & > section {
    margin: 0;
    flex: 1 1 50%;
  }
`

export const PrimaryTitle = styled.h1`
  color: ${colors.white};
  font-size: 32px;
  margin: 0;
  padding-bottom: 32px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    padding-bottom: 24px;
    font-size: 28px;
  }
`

export const SecondaryTitle = styled.h2`
  font-weight: normal;
  margin-top: 0;
  height: fit-content;
  font-size: 24px;
  margin-bottom: 40px;
  display: inline-block;
  position: relative;

  &:after {
    content: '';
    height: 4px;
    width: 24px;
    background: ${colors.redRibbon};
    position: absolute;
    left: 0;
    bottom: -12px;
    border-radius: 100px;
  }
`

export const TertiaryTitle = styled.h3`
  font-size: 16px;
  margin-top: 0;
`

export const ModuleHeaderContainer = styled.div`
  color: #262626;
  font-size: 22px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-top: 40px;
  padding-bottom: 12px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    font-size: 18px;
  }
`

export const ModuleContentContainer = styled.div``

export const SplittedModuleContentContainer = styled.div`
  display: flex;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    flex-direction: column;
  }

  & > div {
    flex: 1;

    &:first-child {
      padding-right: 88px;
    }

    @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
      flex-direction: column;

      &:first-child {
        padding-right: 0px;
        margin-bottom: 24px;
      }
    }
  }
`
